import { useTranslation } from 'react-i18next';
import { LanguageDropdown } from './LanguageDropdown';

export function Topbar() {
  const { t } = useTranslation();
  return (
    <header className="mp-topbar">
      <div className="mp-topbar__search">
        <i className="bi bi-search"></i>
        <input type="text" placeholder={t('searchPlaceholder')} />
      </div>
      <div className="mp-topbar__right">
        <LanguageDropdown />
        <button type="button" className="mp-topbar__icon" title={t('notif')}>
          <i className="bi bi-bell"></i>
          <span className="mp-topbar__dot"></span>
        </button>
        <div className="mp-topbar__user">
          <div className="mp-topbar__avatar"><i className="bi bi-person-fill"></i></div>
          <div className="mp-topbar__usertext">
            <strong>{t('userName')}</strong>
            <span>{t('userOrg')}</span>
          </div>
        </div>
        <button type="button" className="mp-topbar__logout">{t('logout')}</button>
      </div>
    </header>
  );
}
